import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { checkChanges } from '../../utils/checkChanges';
import { decodeSearch, encodeSearch } from '../../utils/url';
import {
  NEW_BOOKING_PROMPT,
} from '../../constants/promptMessages';

import List from './List';
import Loan from './Loan';
import Payment from './Payment';
import LPPSA from './LPPSA';
import New from './New';
// import Overview from './OverviewOld';
import Overview from './Overview';
import Manage from './ManageOld';
import Activities from './Activities';
import CreditCheck from './CreditCheck';
import ManageBookings from './Manage/Manage';
import HIMSBookingSync from './HIMSBookingSync';
import CustomEdit from './customEdit';
import config from '../../../config';
import UnitProgress from './UnitProgress/UnitProgress';
import { isCountryVietnam } from '../../constants/countries';
import { resolveSharedMediaParent } from '../../utils/sharedMedia';

class Bookings extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdmin: PropTypes.bool,
    }),
    params: PropTypes.shape({
      id: PropTypes.string,
      customerID: PropTypes.string,
    }),
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })

  static List = List
  static Loan = Loan
  static Payment = Payment
  static LPPSA = LPPSA
  static New = checkChanges(New, { message: NEW_BOOKING_PROMPT })
  static Overview = checkChanges(Overview)
  static ManageBookings = ManageBookings
  static Manage = Manage
  static Activities = Activities
  static CreditCheck = checkChanges(CreditCheck)
  static HIMSBookingSync = HIMSBookingSync
  static UnitProgress = UnitProgress
  static CustomEdit = CustomEdit

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      loading: true,
      data: null,
      unitTiers: [],
      bookingPP: [],
      bookingFP: [],
      opportunity: undefined,
      documentData: undefined,
    };
  }
  componentDidMount() {
    if (this.props.location.pathname.includes('credit_check/') && this.props.location.pathname.includes('customers/')) {
      this.fetchCustomer();
    } else if (
      this.props.location.pathname.includes('/new/') ||
      this.props.params.id
    ) {
      this.fetchBooking();
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname } = nextProps.location;
    if ((pathname.includes('/credit_check/' && pathname.includes('customers/')) || nextProps.params.customerID)) {
      this.fetchCustomer();
    } else if (
      pathname.includes('/new/') ||
      nextProps.params.id
    ) {
      this.fetchBooking();
    }
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  allowedPath = (props) => {
    const { pathname } = props.location;
    if (pathname.includes('/manage/')) {
      return false;
    }
    return true;
  }
  async fetchprojectBookingCustomFields(projectID) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/booking_custom_fields/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const projectBookingCustomFields = await res.json();
      await this.setComponentState({
        projectBookingCustomFields,
      });
    }
    await this.setLoading(false);
  }
  async fetchBooking() {
    await this.setLoading(true);
    const { store } = this.context;
    const { auth } = this.props;
    const query = decodeSearch(this.props.location.search);
    let url = '/bookings/';
    if (this.props.params.id) {
      url += `${this.props.params.id}/`;
    }
    if (this.props.location.pathname.includes('/new/')) {
      query.token = 'true';
      query.limit = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${url}?${encodeSearch(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      let data = null;
      if (this.props.params.id) {
        data = await res.json();
        await this.fetchprojectBookingCustomFields(data.project.id);
        await this.fetchUnitTierPricing(data);
        if (
          auth.isAdminBasic ||
          auth.isSuperAdmin ||
          auth.isAdmin ||
          auth.isDeveloperSupervisor ||
          auth.isDeveloperSalesManager ||
          auth.isDeveloperSalesAdmin ||
          auth.isHeadquarters
        ) {
          await Promise.all([
            this.fetchBookingPP(data.id),
            this.fetchBookingFP(data.id),
          ]);
        }
        // CPI-974 (E): the cancel action needs the CRM opportunity behind the booking. VN only.
        if (isCountryVietnam(auth.company && auth.company.countryCode) && data.leadOpportunityID) {
          await this.fetchOpportunity(data.leadOpportunityID);
        }
        // CPI-1249: the Vietnam Documents tab reads shared media, not the secure document store.
        if (isCountryVietnam(auth.company && auth.company.countryCode)) {
          await this.fetchDocument(data);
        }
      }
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchBookingPP(bookingID) {
    const { store } = this.context;
    let res = [];
    await this.setLoading(true);
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/bookings/${bookingID}/available_package_pricings/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    const bookingPP = await res.json();
    await this.setComponentState({ bookingPP });
  }
  async fetchBookingFP(bookingID) {
    const { store } = this.context;
    let res = [];
    await this.setLoading(true);
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/bookings/${bookingID}/fee_packages/available/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    await this.setLoading(false);
    const bookingFP = await res.json();
    await this.setComponentState({ bookingFP });
  }
  async fetchCustomer() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.props.params.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        data,
      });
    }
    await this.setLoading(false);
  }
  async fetchUnitTierPricing(data) {
    const { projectID, projectUnitID } = data;
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${projectUnitID}/pricings/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const unitTiers = await res.json();
    await this.setComponentState({ unitTiers });
    await this.setLoading(false);
  }
  // CPI-974 (E): GET /opportunity/{id}/, read-only - only used to detect/display the linked CRM
  // record (canShowVNCancel, srCode); the cancel action itself never writes to it.
  async fetchOpportunity(opportunityID) {
    const { store } = this.context;
    if (!opportunityID) return;
    try {
      const res = await store.dispatch(fetchM(`/opportunity/${opportunityID}/`, {
        credentials: 'include',
        method: 'GET',
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      if (res && res.ok) {
        const opportunity = await res.json();
        await this.setComponentState({
          opportunity,
        });
      }
    } catch (err) {
      Bugsnag.notifyException(err);
    }
  }
  // Sales Overview cancel action: writes only to the booking (pending_cancellation + the reason),
  // never to the CRM opportunity - Sales and Booking cancellation are deliberately decoupled.
  handleRequestBookingCancellation = async (reason = '', cancellationType = '') => {
    const { store } = this.context;
    const { data, token } = this.state;
    if (!data || !data.id) return;
    try {
      await this.setLoading(true);
      const res = await store.dispatch(fetchM(`/bookings/${data.id}/cancellation_request/`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          srCancellationReason: reason || '-',
          srCancellationType: cancellationType,
        }),
      }));
      if (res.ok) {
        await this.fetchBooking();
      } else {
        const errorText = await res.text();
        store.dispatch(flashErrorMessage({ message: errorText }));
      }
    } catch (err) {
      Bugsnag.notifyException(err);
    } finally {
      await this.setLoading(false);
    }
  }
  // CPI-1249 (A20/A21): one document set per sale - filed against the CRM opportunity when the
  // booking came from one, and against the booking itself when it did not.
  async fetchDocument(booking = null) {
    const { store } = this.context;
    const data = booking || this.state.data;
    const { parentType, parentID } = resolveSharedMediaParent(data, this.props.params.id);

    // A blank parent_id would return every active shared media in the database. Never ask.
    if (!parentID) return;

    try {
      const res = await store.dispatch(fetchM(`/shared_medias/?parent_type=${parentType}&parent_id=${parentID}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }));

      if (res.ok) {
        const documentData = await res.json();
        await this.setComponentState({ documentData: documentData || [] });
      }
    } catch (err) {
      Bugsnag.notifyException(err);
    }
  }
  handleFetchNewBooking = callBack => new Promise((res) => {
    this.fetchBooking().then(() => {
      res();
      if (callBack) callBack();
    });
  });
  renderChild() {
    const childProp = {
      token: this.state.token,
      loading: this.state.loading,
      fetchNewBooking: this.handleFetchNewBooking,
    };
    if (this.props.params.id) {
      childProp.data = this.state.data;
      childProp.projectBookingCustomFields = this.state.projectBookingCustomFields;
      childProp.unitTiers = this.state.unitTiers;
      childProp.routeParamsID = this.props.params.id || '';
      childProp.bookingPP = this.state.bookingPP || [];
      childProp.bookingFP = this.state.bookingFP || [];
      childProp.opportunity = this.state.opportunity;
      const { auth } = this.props;
      if (isCountryVietnam(auth && auth.company && auth.company.countryCode)) {
        const parent = resolveSharedMediaParent(this.state.data, this.props.params.id);
        childProp.documentData = this.state.documentData;
        childProp.fetchDocument = () => this.fetchDocument();
        childProp.parentType = parent.parentType;
        childProp.parentID = parent.parentID;
        childProp.onRequestBookingCancellation = this.handleRequestBookingCancellation;
      }
    }
    return Children.map(this.props.children, child => (
      React.cloneElement(child, childProp)
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}

export default connect(Bookings.mapStateToProps)(Bookings);



// WEBPACK FOOTER //
// ./src/containers/Bookings/Bookings.jsx